/**
 * Alerts Page
 *
 * Unified alerts dashboard aggregating all alert types.
 */

import React from 'react';
import AlertsDashboard from '../AlertsDashboard';

export default function AlertsPage() {
  return <AlertsDashboard />;
}
